import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Button } from '@codex-brightworld/basics';

const SaveDate = styled.p`
  margin-top: 8px;
  width: 100%;
  color: ${props => props.theme.colors.neutral.grey[4]};
  text-align: center;
  font-size: 14px;
`;

const FixedMaxWidthButton = styled(Button)`
  max-width: 320px;
`;

class AddToBasketButton extends PureComponent {

  submitHandler = (event) => {
    if (typeof this.props.onFormSubmit === 'function') {
      event.preventDefault();

      this.props.onFormSubmit(() => {
        this.submitForm.submit();
      });
    }
  };

  render() {
    const { props } = this;

    return (
      <form
        ref={(submitForm) => { this.submitForm = submitForm; }}
        data-component="AddToBasketButton"
        action={props.postUrl}
        method="POST"
        onSubmit={this.submitHandler}
        data-qa={props.qa}
      >
        <div className="dc-hidden">
          <input type="hidden" name="subaction" value="cart" />
          <input type="hidden" name="sFUPID" value={props.productId} />
          <input type="hidden" name="iQuantity" value="1" />
          <input type="hidden" name="action" value="addProduct" />
          {props.placement === AddToBasketButton.placements.WISHLIST &&
            <input type="hidden" name="wasAddedFromWishlist" value />}
          {props.placement === AddToBasketButton.placements.BUNDLE &&
            props.renderAdditionalHiddenInputs()}
        </div>

        <FixedMaxWidthButton
          dataInteraction="add-to-basket"
          type="submit"
          primary={!props.isDownload}
        >
          {props.children}
        </FixedMaxWidthButton>

        {props.placement === AddToBasketButton.placements.WISHLIST &&
          <SaveDate>{props.savedOnLabel} {props.savedOn}</SaveDate>}
      </form>
    );
  }
}

AddToBasketButton.displayName = 'AddToBasketButton';

AddToBasketButton.placements = {
  BUNDLE: 'BUNDLE',
  WISHLIST: 'WISHLIST',
  SIMILAR_PRODUCT: 'SIMILAR_PRODUCT'
};

AddToBasketButton.propTypes = {
  classes: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.string
  ]).isRequired,
  productId: PropTypes.string.isRequired,
  postUrl: PropTypes.string.isRequired,
  onFormSubmit: PropTypes.func,
  renderAdditionalHiddenInputs: PropTypes.func,
  savedOn: PropTypes.string,
  savedOnLabel: PropTypes.string,
  placement: PropTypes.oneOf(
    Object.values(AddToBasketButton.placements)
  ),
  isDownload: PropTypes.bool,
  qa: PropTypes.string
};

AddToBasketButton.defaultProps = {
  classes: '',
  savedOn: '',
  savedOnLabel: 'Saved on',
  placement: AddToBasketButton.placements.WISHLIST,
  isDownload: false,
  onFormSubmit: undefined,
  renderAdditionalHiddenInputs: () => <noscript />,
  qa: undefined
};

export default AddToBasketButton;
